import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import Chart from "react-apexcharts";

import { CircularProgress, useTheme } from "@mui/material";

import useZone from "../../../../../hooks/user/useZone";
import { Card as MuiCard, CardContent, CardStyle } from "../../../common/styled";

const Card = styled(MuiCard)`
  position: relative;
  border-radius: 3px;
  width: calc(100%- 258px);
  height: calc(40vw - 90px);
  ${CardStyle};
`;

const ChartWrapper = styled.div`
  height: 100%;
`;
const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;
const LLMDetectChart = ({ setCustomRangeConfirm, setTimeRange, setCustomDateRange }) => {
  const theme = useTheme();
  const { sigs, mls, llmsigs } = useZone();
  const [data, setData] = React.useState([
    {
      name: "LLM Guardrail",
      data: [],
    }
  ]);
  const [options, setOptions] = React.useState({
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "datetime",
      categories: [],
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    chart: {
    },
    colors: [theme.palette.custom.green.main],
  });

  React.useEffect(() => {
    var categories = [];
    var llmSigDatas = [];
    if (llmsigs?.length > 0) {
      llmsigs.forEach((llmsig) => {
        categories.push(llmsig.key_as_string);
      });
    }
    // Remove duplicated entries
    categories = Array.from(new Set(categories));
    categories.sort();
    if (categories.length > 0) {
      categories.forEach((cate) => {
        if (null === llmsigs || 0 === llmsigs.length) {
          llmSigDatas.push(0);
        } else {
          let sig = llmsigs.find((x) => x.key_as_string === cate);
          if (undefined === sig) {
            llmSigDatas.push(0);
          } else {
            llmSigDatas.push(sig.doc_count);
          }
        }
      });
    }
    setData([
      {
        name: "LLM Guardrail",
        data: llmSigDatas,
      },
    ]);
    setOptions({
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: categories,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      chart: {
        events: {
          zoomed: function (chartContext, { xaxis, yaxis }) {
            if (xaxis.min === undefined || xaxis.max === undefined) {
              setTimeRange("1d");
            } else {
              const from = new Date(xaxis.min);
              const to = new Date(xaxis.max);
              const month = String(from.getMonth() + 1).padStart(2, "0");
              const date = String(from.getDate()).padStart(2, "0");
              const year = String(from.getFullYear());
              const hour = String(from.getHours()).padStart(2, "0");
              const minute = String(from.getMinutes()).padStart(2, "0");
              const second = String(from.getSeconds()).padStart(2, "0");
              const _month = String(to.getMonth() + 1).padStart(2, "0");
              const _date = String(to.getDate()).padStart(2, "0");
              const _year = String(to.getFullYear());
              const _hour = String(to.getHours()).padStart(2, "0");
              const _minute = String(to.getMinutes()).padStart(2, "0");
              const _second = String(to.getSeconds()).padStart(2, "0");
              setTimeRange("custom");
              setCustomRangeConfirm(true);
              setCustomDateRange([
                year + "-" + month + "-" + date + "T" + hour + ":" + minute + ":" + second,
                _year + "-" + _month + "-" + _date + "T" + _hour + ":" + _minute + ":" + _second,
              ]);
            }
          },
        },
      },
      colors: [theme.palette.custom.green.main],
    });
  }, [llmsigs]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card sx={{ boxShadow: "none" }}>
      <CardContent sx={{ background: "white", height: "100%" }}>
        <ChartWrapper>
          {sigs === null || mls === null ? (
            <Root>
              <CircularProgress color="primary" />
            </Root>
          ) : (
            <Chart options={options} series={data} type="line" height={"100%"} />
          )}
        </ChartWrapper>
      </CardContent>
    </Card>
  );
};

export default withTheme(LLMDetectChart);
